import { render, staticRenderFns } from "./LayerSelector.vue?vue&type=template&id=65234ade&scoped=true"
import script from "./LayerSelector.vue?vue&type=script&lang=js"
export * from "./LayerSelector.vue?vue&type=script&lang=js"
import style0 from "./LayerSelector.vue?vue&type=style&index=0&id=65234ade&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65234ade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65234ade')) {
      api.createRecord('65234ade', component.options)
    } else {
      api.reload('65234ade', component.options)
    }
    module.hot.accept("./LayerSelector.vue?vue&type=template&id=65234ade&scoped=true", function () {
      api.rerender('65234ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/psd-layers/LayerSelector.vue"
export default component.exports